export default class Item {
    constructor(
        id,
        type,
        name,
        icon,
        description,
        price,
        consumable = true,
        stackable = false,
        stackCount = 1,
    ) {
        this.id = id;
        this.type = type;
        this.name = name;
        this.icon = icon
        this.description = description;
        this.price = price;
        this.consumable = consumable;
        this.stackable = stackable;
        this.stackCount = stackCount;
    }
}